<template>
<div class="customManage">
  <div class="main-con">
<!--    搜索-->
    <div class="custom_search">
      <el-form class="from_search" label-position="left" label-width="80px">
        <el-form-item label="客户名称">
          <el-input v-model="form.customerName" placeholder="请输入客户名称" @change="getSearch" style="width: 216px;margin-right: 16px"></el-input>
        </el-form-item>
        <el-form-item label="所属省市">
          <el-select
            v-model="form.province"
            style="width: 181px"
            placeholder="请选择"
            @change="handleProvinceChange"
          >
            <el-option
              v-for="item in provinceList"
              :key="item.province"
              :label="item.province"
              :value="item.province"
            ></el-option>
          </el-select>
          <el-select v-model="form.city" placeholder="请选择" style="margin-left: 10px;width: 181px">
            <el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="el-but">
          <el-button style="margin-left: 16px" type="primary" icon="el-icon-search" plain @click="getSearch">查询</el-button>
          <el-button style="margin-left: 16px;" plain icon="el-icon-delete" @click="getDelete">清空</el-button>
        </el-form-item>
      </el-form>
    </div>
<!--    表格数据-->
    <div class="custom_table" style="margin-top: 16px">
      <div style="padding: 16px 24px">
        <div class="title_tab">
          全部客户
        </div>
        <el-table
          style="margin-top: 16px;border: 1px solid #eeeeee"
        :data="customList"
        :header-cell-style="{background:'#EBE9E9', color:'#000000', fontsize:'16px'}"
        :cell-style="{ color: 'rgba(0,0,0,0.85)', fontsize:'14px'}">
          <el-table-column label="客户名称">
            <template slot-scope="scope">
              <div class="table_one">
                <div
                  class="pic"
                :style="{ 'backgroundColor': str[scope.row.colorLenght]}">
                  {{scope.row.picName}}
                </div>
                <div style="width: 90%">{{scope.row.customerName}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="所属省市">
            <template slot-scope="scope">
              {{scope.row.province}}-{{scope.row.city}}
            </template>
          </el-table-column>
          <el-table-column label="项目数量" prop="projectNum"></el-table-column>
          <el-table-column label="操作" header-align="left" align="left">
            <template slot-scope="scope">
              <el-button type="text" @click="getDetails(scope.row.customerName)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            @size-change="sizeChangeHandleHis"
            @current-change="currentChangeHandleHis"
            :current-page="pageNum"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="pageSize"
            :total="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            style="text-align: right;padding-bottom: 20px;margin: 25px 50px">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
  <!--    指引视频-->
  <div class="video_but" v-if="viodeShow">
    <img src="../../assets/btn_close@2x.png" class="btn" @click="viodeShow = false"/>
    <img src="../../assets/pic_videoguide@2x.png" style="width: 120px;height: 120px;padding-top: 20px" @click="videoPlay"/>
  </div>
  <!--    弹窗视频-->
  <el-dialog
    :visible.sync="dialogviode"
    width="40%"
    title="指引视频">
    <div>
      暂无指引视频。。。。。。
<!--      <div class="videoDom">-->
<!--        <div class="video">-->
<!--          <video-->
<!--            x5-playsinline="true"-->
<!--            playsinline="true"-->
<!--            webkit-playsinline="true"-->
<!--            class="videodom"-->
<!--            preload="auto"-->
<!--            controls-->
<!--            ref="videoNode"-->
<!--            style="-->
<!--                width: 100%;-->
<!--              "-->
<!--            :src="fileUrl"-->
<!--          ></video>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </el-dialog>
</div>
</template>

<script>
import {getcustomList} from '@/api/customManage'
export default {
  name: "customManage",
  data() {
    return {
      provinceList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      form:{
        customerName: '',
        province: '',
        city: ''
      },
      customList: [],
      str: ['#E60027 ', '#F1953D ', '#EBC157'],
      // 视频
      dialogviode: false,
      // fileUrl: 'https://mxxxbucket.oss-cn-guangzhou.aliyuncs.com/平台使用指引视频-【业绩清单】操作流程.mp4',
      viodeShow: true,
    }
  },
  computed: {
    cityList() {
      let result = [];
      if (this.form.province) {
        const cityObj = this.provinceList.find(item => item.province == this.form.province);
        if (cityObj) {
          result = cityObj.cities.map(item => {
            return { value: item, lable: item };
          });
        }
      }
      return result;
    },
  },
  // 路由跳转之前保存当前滚动条的位置。
  beforeRouteLeave(to, from, next) {
    this.scroll = document.getElementsByClassName(
      "el-table__body-wrapper"
    )[0].scrollTop;
    next();
  },
//使用keepAlive缓存组件状态，页面切换路由会触发 activated 钩子函数。在 activated 中将 之前记录的位置赋值给引起滚动条滚动元素的 scrollTop
  activated(){
    this.$nextTick(() => {
      setTimeout(() => {
// 也可以使用 document.getElementsByClassName("el-table__body-wrapper")[0].scrollTop = this.scroll
        this.$refs.table.bodyWrapper.scrollTop = this.scroll;
      }, 0);
    });
  },
  methods: {
    // 关闭视频
    videoPlayClose() {
      // this.$refs.videoNode.pause();
      this.dialogviode = false
      // clearTimeout()
      // this.fileUrl = ''
    },
    videoPlay() {
      this.dialogviode = true
      // this.fileUrl = 'https://mxxxbucket.oss-cn-guangzhou.aliyuncs.com/平台使用指引视频-【业绩清单】操作流程.mp4'
      // setTimeout(()=> {
      //   this.$refs.videoNode.play()
      // }, 1000)
    },
    getDelete(){
      this.form.customerName = ''
      this.form.province = ''
      this.form.city = ''
      this.pageNum = 1
      this.getTableList()
    },
    // 跳转详情页
    getDetails(customerName) {
      this.$router.push({
        path: `/manage/detailsTalk`,
        query: {
          customerName: customerName
        },
      });
    },
    getSearch() {
      this.pageNum = 1
      this.getTableList()
    },
    // 每页数
    sizeChangeHandleHis (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getTableList()
    },
    // 当前页
    currentChangeHandleHis (val) {
      this.pageNum = val
      this.getTableList()
    },
    getCityList() {
      this.$request.getCityList().then(res => {
        console.log(res, "城市");
        if (res.code == 200) {
          this.provinceList = res.data;
        }
      });
    },
    handleProvinceChange(e) {
      console.log(e);
      this.form.city = undefined;
    },
    getTableList() {
      const data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        customerName: this.form.customerName,
        province: this.form.province,
        city: this.form.city
      }
      getcustomList(data).then(res => {
        res.data.records.forEach( item => {
          item.picName = item.customerName.slice(0,2)
          item.colorLenght = parseInt(Math.random() * this.str.length)
        })
        this.total = res.data.total
        this.customList = res.data.records
      })
    }
  },
  mounted() {
    this.getCityList()
    this.getTableList()
  }
}
</script>

<style scoped lang="less">
// 视频
.videoDom {
  //width: 50%;
  position: relative;
}
// 视频
.video {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
  position: relative;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  // 遮罩层
  .video_overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  // 播放
  .video_play {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  video {
    vertical-align: middle;
  }
}
.btn{
  height: 30px;
  width: 30px;
  position: fixed;
  right: 40px;
  margin-bottom: 50px;

}
.video_but{
  color: white;
  position: fixed;
  right: 50px;
  bottom: 100px;
  cursor: pointer;
}
.el-but{
  ::v-deep .el-form-item__content{
    margin-left: 0px !important;
  }
}
.el-table{
  ::v-deep .el-button{
    padding: 0px !important;
  }
}
.table_one{
  display: flex;
  align-items: center;
}
.pic{
  font-size: 12px !important;
   width: 32px;
   height: 32px;
   border-radius: 4px;
   color: white;
   text-align: center;
  line-height: 32px;
  margin-right: 8px;
 }
.customManage {
  height: 100%;
  background-color: #F4F4F5;
& > .main-con {
    padding: 16px 0px;
    width: 15.04rem;
    margin: 0 auto;
    min-width: 1000px;
  }
}
.custom_search, .custom_table{
  width: 100%;
  background-color: #fff;
}
.from_search{
  display: flex;
  flex-wrap: wrap;
  padding: 16px 24px;
  .el-form-item{
    margin: 0 !important;
  }
  ::v-deep .el-form-item__label{
    padding: 0 !important;
  }
  ::v-deep .el-input__inner{
    height: 32px !important;
  }
}
.title_tab{
  font-size: 20px;
  font-weight: bold;
  color: rgba(0,0,0,0.85);
  line-height: 28px;
}
</style>
